import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.deeplearning');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-deeplearning',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.deeplearning/view.scss */
.deeplearning-page {
  min-height: 100vh;
  background: #f6f8fb;
  color: #111827;
  padding: 32px;
}

.dl-head,
.problem-band,
.classification-band,
.flow-band,
.recent-band,
.paper-detail-band,
.position-band,
.paper-band {
  max-width: 1480px;
  margin: 0 auto 18px;
}

.dl-head {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 420px);
  gap: 24px;
  align-items: end;
}

.title-block .eyebrow {
  margin: 0 0 10px;
  color: #0f766e;
  font-size: 13px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}
.title-block h1 {
  margin: 0;
  color: #0f172a;
  font-size: 38px;
  font-weight: 900;
  line-height: 1.14;
  letter-spacing: 0;
}
.title-block .summary {
  max-width: 920px;
  margin: 14px 0 0;
  color: #475569;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.6;
}

.top-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #0f172a;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}
.nav-link:hover {
  border-color: #0f766e;
  background: #f0fdfa;
  color: #0f766e;
}

.report-meta {
  display: grid;
  gap: 8px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
  padding: 16px;
}
.report-meta span {
  color: #64748b;
  font-size: 12px;
  font-weight: 850;
  text-transform: uppercase;
}
.report-meta strong {
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
  overflow-wrap: anywhere;
}
.report-meta small {
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
}

.problem-band,
.flow-band,
.position-band {
  display: grid;
  grid-template-columns: minmax(300px, 0.85fr) minmax(0, 1.15fr);
  gap: 18px;
  align-items: stretch;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  padding: 18px;
}

.classification-band,
.recent-band,
.paper-detail-band,
.paper-band {
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  padding: 18px;
}

.section-copy {
  display: grid;
  align-content: start;
  gap: 14px;
}
.section-copy .section-kicker {
  margin: 0;
  color: #0f766e;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}
.section-copy h2 {
  margin: 0;
  color: #0f172a;
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 0;
}
.section-copy p {
  margin: 0;
  color: #475569;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.65;
}

.claim-box {
  display: grid;
  gap: 6px;
  border-left: 4px solid #0f766e;
  background: #ecfdf5;
  padding: 12px 14px;
}
.claim-box strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}
.claim-box span {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
}

.triangle-panel {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 12px;
  min-height: 320px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(14, 165, 233, 0.08), rgba(16, 185, 129, 0.08)), #f8fafc;
  padding: 18px;
}

.triangle-node {
  display: grid;
  align-content: center;
  gap: 8px;
  min-height: 118px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  padding: 16px;
}
.triangle-node strong {
  color: #0f172a;
  font-size: 16px;
  font-weight: 900;
}
.triangle-node span {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
}

.triangle-node.retrieval {
  border-left: 5px solid #38bdf8;
}

.triangle-node.context {
  border-left: 5px solid #22c55e;
}

.triangle-node.generation {
  grid-column: 1/-1;
  border-left: 5px solid #a78bfa;
}

.panel-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: end;
  margin-bottom: 14px;
}
.panel-head h2 {
  margin: 0;
  color: #0f172a;
  font-size: 23px;
  font-weight: 900;
  letter-spacing: 0;
}
.panel-head span {
  color: #64748b;
  font-size: 13px;
  font-weight: 800;
  text-align: right;
}

.table-wrap {
  overflow-x: auto;
}

table {
  width: 100%;
  min-width: 860px;
  border-collapse: collapse;
  font-size: 13px;
}
table th,
table td {
  border: 1px solid #e2e8f0;
  padding: 11px 12px;
  color: #334155;
  line-height: 1.45;
  vertical-align: top;
}
table th {
  background: #ecfdf5;
  color: #0f172a;
  font-weight: 900;
  text-align: left;
}
table td:first-child {
  color: #0f172a;
  font-weight: 900;
  white-space: nowrap;
}

.failure-flow {
  display: grid;
  grid-template-columns: 1fr 42px 1fr 42px 1fr;
  gap: 8px;
  align-items: center;
  min-height: 250px;
}
.failure-flow i {
  color: #64748b;
  font-size: 22px;
  text-align: center;
}
.failure-flow article {
  display: grid;
  gap: 8px;
  min-height: 170px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #f8fafc;
  padding: 16px;
}
.failure-flow article span {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #dbeafe;
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 900;
}
.failure-flow strong {
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
}
.failure-flow small {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.5;
}

.recent-grid,
.paper-detail-grid,
.position-grid,
.paper-list {
  display: grid;
  gap: 12px;
}

.recent-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.paper-detail-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.recent-grid article,
.paper-detail-grid article,
.position-grid article,
.paper-list article {
  display: grid;
  gap: 7px;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #f8fafc;
  padding: 14px;
}

.recent-grid strong,
.paper-detail-grid strong,
.position-grid strong,
.paper-list strong {
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
}

.recent-grid span,
.paper-list span,
.position-grid span {
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.45;
}

.recent-grid p {
  margin: 0;
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  line-height: 1.5;
}

.paper-detail-grid dl {
  display: grid;
  grid-template-columns: 44px minmax(0, 1fr);
  gap: 6px 8px;
  margin: 0;
}

.paper-detail-grid dt {
  color: #0f766e;
  font-size: 12px;
  font-weight: 900;
}

.paper-detail-grid dd {
  margin: 0;
  color: #475569;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.45;
}

.position-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.position-grid i {
  color: #0f766e;
  font-size: 22px;
}

.paper-list {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 980px) {
  .deeplearning-page {
    padding: 20px;
  }
  .dl-head,
  .problem-band,
  .flow-band,
  .position-band {
    grid-template-columns: 1fr;
  }
  .recent-grid,
  .paper-detail-grid,
  .position-grid,
  .paper-list {
    grid-template-columns: 1fr;
  }
  .failure-flow {
    grid-template-columns: 1fr;
  }
  .failure-flow i {
    transform: rotate(90deg);
  }
  .panel-head {
    display: grid;
    align-items: start;
  }
  .panel-head span {
    text-align: left;
  }
  .title-block h1 {
    font-size: 31px;
  }
}`],
})
export class PageDeeplearningComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init(this);
    }
}

export default PageDeeplearningComponent;